import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import { Dep } from '../class/auth';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-storyactive',
    templateUrl: './storyactive.component.html',
    styleUrls: ['./storyactive.component.css']
})
export class StoryactiveComponent implements OnInit {

    time :any={};
    tool_obj: any = {
        search_model:'',
        lock_status:'-1',
        kyc_status:'-1',
        process_action:'-1',
        gender_action:'-1',
        identity_action:'-1',
        chosen_action:'-2',
        process_list:[],
        active_id:'-1',
        type:'-2',
        active_type_id:'-2',
        ranking_active_type_id:'-2',
        searchFileType : '1',
    }
    data:any=[];
    time_info:any=-1;
    top_info:any={};
    link:string = environment.link;
    edit_data:any={id:'-1',description:'',start_dt:'',end_dt:'',target_type:'1',status:1,type:'0'};
    user:any=[]
    now:any = '2';
    loading:boolean=true;
    pageobj:page = {page:0, count:20, total_count:0};
    pageobj2:page = {page:0, count:8, total_count:0};
    menu_list:menulist = [{id:'2',name:'活動設定'},{id:'1',name:'動態列表'},{id:'3',name:'排行榜'}];
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
    rank_type:number = 1;
    alert_list = [];

    type_list:menulist=[
        {id:'0',name:'動態'},
        {id:'1',name:'語音/視訊'}
    ];

    target_type_list:menulist=[
        {id:'1',name:'上傳單次'},
        {id:'2',name:'解鎖數'},
        {id:'3',name:'愛心數'},
        {id:'4',name:'留言數'},
        {id:'5',name:'鑽石數'},
        {id:'6',name:'觀看次數'},
        {id:'7',name:'語音/視訊'},
    ];
    active_option:any=[];
    active_option_type: any = [{id:'1', name:"正常"}, {id:'6', name:"盜圖"}];

    ranking_active_type:any = [
        {id:'-2',name:'全部'},
        // {id:'-3',name:'未審核'},
        {id:'1',name:'符合'},
        {id:'-1',name:'不符合'},
    ];

    active_type:any = [
        {id:'-2',name:'全部'},
        {id:'-3',name:'未審核'},
        {id:'1',name:'符合'},
        {id:'-1',name:'不符合'},
    ];

    tcontent:any = [
        {title:'活動名稱',content:'description',css:'min-width: 300px;'},
        {title:'競賽標的',content:'target_name',css:'min-width: 300px;'},
        {title:'開始',content:'start_dt',css:'min-width: 300px;'},
        {title:'結束',content:'end_dt',css:'min-width: 300px;'},
        {title:'狀態',content:'status_name',css:'min-width: 300px;'},
        {title:'操作',content:'gg',type:3},
    ];


    lock_option_list:menulist=[
        {id:'-1',name:'全部'},
        {id:'0',name:'免費動態'},
        {id:'1',name:'付費動態'},
    ];
    kyc_option_list:menulist=[
        {id:'-1',name:'全部'},
        {id:'0',name:'沒過kyc'},
        {id:'1',name:'有過kyc'},
    ];
    process_option_list:any=[
        {id:'0',name:'取消'},
        {id:'1',name:'符合'},
        {id:'-1',name:'不符合'},
    ];
    gender_option_list:menulist=[
        {id:'-1',name:'全部'},
        {id:'1',name:'男生'},
        {id:'2',name:'女生'},
    ];
    identity_option_list:menulist=[
        {id:'-1',name:'全部'},
        {id:'1',name:'一般'},
        {id:'3',name:'經紀'},
    ];
    chosen_option_list:menulist=[
        {id:'-2',name:'全部'},
        {id:'-1',name:'非精選'},
        {id:'0',name:'待審核'},
        {id:'1',name:'精選'},
    ];

    type_option_list:menulist=[
        {id:'0',name:'全部'},
        {id:'3',name:'圖片'},
        {id:'4',name:'影片'},
    ];

    ranges: any = {
        '過去一個月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        '過去一周': [moment().subtract(6, 'days'), moment()],
        '昨天': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '今天': [moment(), moment()],
        '未來一周': [moment().subtract(-6, 'days'), moment()],
        '未來30天': [moment().subtract(-29, 'days'), moment()],
        '本月': [moment().startOf('month'), moment().endOf('month')],
        '下一個月': [moment().subtract(-1, 'month').startOf('month'), moment().subtract(-1, 'month').endOf('month')]
    }
    sort_obj:any = { //表格排序
        column:'all',
        sort:'0'
    }

    search_model:any = '';
    group:any = [];
    alert_data:any = [];

    constructor(
        public httpClient: HttpClient,
    ) { }

    validateInput(event: KeyboardEvent) {
        const char = event.key;
        if (!/[\d.]/.test(char)) {
          event.preventDefault(); // 阻止輸入非法字符
        }
    }

    default_model(){
        this.pageobj.page = 0;
        this.init_list();
    }

    ensureMinValue(i) {
        if (this.data[i].point < 1 || this.data[i].point == null) {
            this.data[i].point = 1; // 若數值小於 1，重設為 1
        }
    }

    ngOnInit(): void {
        this.user = Dep.user;
        this.init_time();
    }

    init_time(){
        let default_status = true;
        if(this.time_info!=-1){
            const tmp = this.time_info.split("_");
            if(tmp.length==4){
                default_status = false;
                this.time.start = tmp[0]
                this.time.end = tmp[1]
                this.time.startDate = moment(tmp[0]);
                this.time.endDate = moment(tmp[1]);
            }
        }

        if(default_status){
            this.time.startDate = moment().subtract(7, 'days');
            this.time.endDate = moment().subtract(0, 'days');
            this.time.start = moment(this.time.startDate)
            this.time.end = moment(this.time.endDate)
        }

        this.init_list();
    }

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    add(){
        this.loading = true;
        const time = JSON.parse(JSON.stringify(this.time))
        time.start =  moment(time.startDate).format('YYYY-MM-DD')
        time.end =  moment(time.endDate).format('YYYY-MM-DD')
        const body = {data:this.edit_data,now:this.now,now_range:time};
        this.httpClient.post<any>("/customer_service/update_story_active.php",body).subscribe(res => {
            this.loading = false;
            this.init_list();
            console.log(res);
        }, error => {
            console.log(error);
        });
    }

    defaultpage(){
        this.pageobj = {page:0,count:20,total_count:0};
    }

    changeNum(item){
        this.loading = true;
        const body = {data:item, action:3};
        this.httpClient.post<any>("/customer_service/get_story_active_list_detail.php",body).subscribe(res => {
            this.loading = false;
            Swal.fire("已修改加權分數!", "", "success");
            this.init_list();
        }, error => {
            console.log(error);
        });
    }

    init_list(){

        if(this.now == '3' && this.rank_type == 1){
            this.tcontent = [
                {title:'用戶名',content:'name',type:2,css:'min-width: 300px;'},
                {title:'大頭貼',content:'profile_pic',type:1,css:'min-width: 300px;'},
                {title:'符合媒體數',content:'ok_num',type:3,sort:'ok_num',css:'min-width: 300px;'},
                {title:'目前總分數',content:'all',sort:'all',css:'min-width: 300px;'},
            ];
        }

        if(this.now == '3' && this.rank_type == 0){
            this.tcontent = [
                {title:'排名',content:'serial_number'},
                {title:'用戶名',content:'name',type:2},
                {title:'大頭貼',content:'profile_pic',type:1},
                {title:'符合媒體數',content:'ok_num',type:3,sort:'ok_num'},
                {title:'原始分數',content:'points',sort:'points',css:'min-width: 300px;'},
                {title:'加權分數',content:'weighted',sort:'weighted',css:'min-width: 300px;',type:3},
                {title:'目前總分數',content:'all',sort:'all',css:'min-width: 300px;'},
                {title:'操作',content:'gg',type:3},
            ];
        }


        this.loading = true;
        const body = {
            search_model: this.search_model,
            sort_obj: this.sort_obj,
            page: this.pageobj.page,
            count: this.pageobj.count,
            search: this.tool_obj.search_model,
            tool: this.tool_obj,
            now: this.now,
            now_range: this.time,
            rank_type: this.rank_type,
            searchFileType: this.tool_obj.searchFileType,
        };
        this.httpClient.post<any>("/customer_service/get_story_acitve_list.php", body).subscribe(res => {
            this.loading = false;
            this.tool_obj.active_id = res.active_id

            if(this.pageobj.page == 0){
                this.active_option = res.active_option
            }

            if(this.now == '3'){
                this.group = res.return_list;
            }


            this.data = res.data

            //補已審核狀態
            if(this.now == '1'){

                this.data.forEach((v,k) => {

                    this.data[k]['check_result'] = this.data[k]['sris_enable'];

                });
            }


            this.pageobj.total_count = res.total_count
            console.log(res);
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        }, error => {
            console.log(error);
        });
    }

    change_type(item){
        this.loading = true;
        const body = {data:item, action:2};
        this.httpClient.post<any>("/customer_service/get_story_active_list_detail.php",body).subscribe(res => {
            this.loading = false;
            Swal.fire("已修改狀態!", "", "success");
            this.init_list();
        }, error => {
            console.log(error);
        });

    }


    get_default(){
        this.edit_data = {id:'-1',description:'',start_dt:'',end_dt:'',target_type:'1',status:1,type:'0'};
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    callback2(pageobj:page){
        if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
            this.pageobj2 = pageobj;
            this.view_detail();
        }
    }

    save_detail(){
        this.loading = true;
        const body = {
            page: this.pageobj2.page,
            count: this.pageobj2.count,
            data: this.edit_data.data,
            tool: this.tool_obj,
            action: 1
        };
        this.httpClient.post<any>("/customer_service/get_story_active_list_detail.php", body).subscribe(res => {
            this.loading = false;
            this.view_detail();
            this.init_list();
        }, error => {
            console.log(error);
        });
    }

    view_detail(){
        this.loading = true;
        const body = {
            page: this.pageobj2.page,
            count: this.pageobj2.count,
            data: this.edit_data,
            tool: this.tool_obj,
            action: 0
        };
        // console.log("this.edit_data: " + JSON.stringify(this.edit_data))
        this.httpClient.post<any>("/customer_service/get_story_active_list_detail.php",body).subscribe(res => {
            this.loading = false;
            this.edit_data.data = res.data
            this.pageobj2.total_count = res.total_count
            console.log(res);
            this.pageobjstr2 = JSON.parse(JSON.stringify(this.pageobj2))
        }, error => {
            console.log(error);
        });
    }

    onRangeSelected(type,value: any) {
        if(value.startDate){
            this.time.start =  moment(value.startDate).format('YYYY-MM-DD')
            this.time.end =  moment(value.endDate).format('YYYY-MM-DD')
        }
    }

    // 支援手動打字輸入日期範圍。ngxDaterangepickerMd 打字(keyup)只更新日曆內部、不回寫 ngModel，
    // 導致送出時 add() 讀到的 time.startDate/endDate 仍是舊值(打的字被忽略)。這裡在 blur 解析輸入字串、回寫 model。
    onDateTyped(event: any) {
        const val = (event && event.target && event.target.value) ? String(event.target.value) : '';
        if (!val) { return; }
        const parts = val.split(' - ');
        if (parts.length !== 2) { return; }
        let s = moment(parts[0].trim(), 'YYYY-MM-DD', true);
        let e = moment(parts[1].trim(), 'YYYY-MM-DD', true);
        if (!s.isValid() || !e.isValid()) { return; } // 無效格式不覆蓋既有值
        if (s.isAfter(e)) { const t = s; s = e; e = t; } // 打字可能前後顛倒，校正成 start<=end(點選不會發生)
        this.time.startDate = s;
        this.time.endDate = e;
        this.time.start = s.format('YYYY-MM-DD');
        this.time.end = e.format('YYYY-MM-DD');
    }

    choose(value:string){
        this.now = value;
        this.pageobj.page = 0;
        this.tool_obj.process_list = [];//重歸0

        if(this.now==1){
            this.time.startDate = moment().subtract(7, 'days');
            this.time.endDate = moment().subtract(0, 'days');
        }else if(this.now==2){
            this.time.startDate = moment().subtract(0, 'days');
            this.time.endDate = moment().subtract(-7, 'days');

            this.tcontent = [
                {title:'活動名稱',content:'description',css:'min-width: 300px;'},
                {title:'競賽標的',content:'target_name',css:'min-width: 300px;'},
                {title:'開始',content:'start_dt',css:'min-width: 300px;'},
                {title:'結束',content:'end_dt',css:'min-width: 300px;'},
                {title:'狀態',content:'status_name',css:'min-width: 300px;'},
                {title:'操作',content:'gg',type:3},
            ];

        }

        this.time.start = moment(this.time.startDate)
        this.time.end = moment(this.time.endDate)
        this.get_default();
        this.init_list();
    }

    choose_item(item){
        const index = this.tool_obj.process_list.findIndex((v)=>{
            return v == item.id;
        })
        if(index==-1){
            this.tool_obj.process_list.push(item.id);
        }else{
            this.tool_obj.process_list.splice(index,1)
        }
    }

    choose_all(type){
        if(type){
            this.data.forEach(element => {
                element.data.forEach(e =>{
                    this.tool_obj.process_list.push(e.id)
                })
            });
        }else{
            this.tool_obj.process_list = [];
        }
    }

    alert_item(item){

        const index = this.alert_list.findIndex((v)=>{
            return v == item.id;
        })

        if(index !=-1){
            this.alert_list.splice(index,1);
            this.alert_data.splice(index,1);
        }

    }

    middle_save(item){
        const choose_option = this.active_option.find(option => option.id === this.tool_obj.active_id) || '';
        //	1:上傳,2:解鎖數,3:點讚,4:留言數,5:鑽石數
        let column = '-1';
        if(item.type==2){
            column = 'delock_num';
        }else if(item.type==3){
            column = 'love';
        }else if(item.type==4){
            column = 'comment_num';
        }else if(item.type==5){
            column = 'diamond';
        }

        if(this.tool_obj.process_list.length==0){
            alert('請選擇標的');
            return;

        }else{

            Object.keys(this.data).forEach((i,k) => {

                const data = this.data[i];

                if (this.tool_obj.process_list.includes(data.id)) {

                    this.data[k].check_result = item.id;
                    const index = this.alert_list.findIndex((v)=>{
                        return v == data.id;
                    })

                    if(index !=-1){
                        if(item.id == 0){
                            this.alert_list.splice(index,1);
                            this.tool_obj.process_list.splice(index,1);
                        }
                    }else{
                        this.alert_list.push(data.id);
                        this.alert_data.push(data);
                    }
                }

            });

        }

    }

    save(){

        this.loading = true;
        const body = {tool:this.tool_obj,now:this.now,data:this.data,alert_data:this.alert_data};
        let pass = 0;
        let unpass = 0;
        for(let i in this.alert_data){

            if(this.alert_data[i].check_result == 1){
                pass ++;
            }else if(this.alert_data[i].check_result == -1){
                unpass ++;
            }

        }


        this.httpClient.post<any>("/customer_service/update_story_active.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                if(pass>0){
                    alert("本次執行符合數為:"+pass+"筆");
                }else if(unpass>0){
                    alert("本次執行不符合數為:"+unpass+"筆");
                }else{
                    alert("未選取已審核選項");
                }
                this.tool_obj.process_list = [];
                this.init_list();
                this.alert_list = [];
                this.alert_data = [];
            }else{
                alert('執行失敗');
            }
            console.log(res);
        }, error => {
            console.log(error);
        });

    }


    middle_click(){
        console.log('middle');
        if(this.tool_obj.process_list.length==0){
            alert('請選擇標的');
        }else{
            this.save();
        }
    }

    go_top(){
        var btn_click = document.getElementById("go_top");
        const tmp = this.getOffset(btn_click);
	  	  this.scrollAnimation(tmp.top,0);
    }

    getOffset (el) {
        const box = el.getBoundingClientRect();
        return{
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft
        }
    }

    scrollAnimation(currentY, targetY) {
        let needScrollTop = targetY - currentY
        let _currentY = currentY
        setTimeout(() => {
            const dist = Math.ceil(needScrollTop / 10)
            _currentY += dist
            window.scrollTo(_currentY, currentY)
            if (needScrollTop > 10 || needScrollTop < -10) {
                this.scrollAnimation(_currentY, targetY)
            } else {
                window.scrollTo(_currentY, targetY)
            }
        }, 10)
    }

}
